// Smooth open/close animation for product accordions using max-height transitions
// Works with markup:
// <div class="accordion"> <details> <summary>...</summary> <div class="accordion__content">...</div> </details> </div>

(function () {
  function initializeAccordionAnimations(root) {
    var detailsElements = Array.prototype.slice.call(
      (root || document).querySelectorAll('.accordion details')
    );
    if (detailsElements.length === 0) return;

    detailsElements.forEach(function (details) {
      var content = details.querySelector('.accordion__content');
      if (!content) return;

      function setMaxHeightNone() {
        content.style.maxHeight = 'none';
        content.setAttribute('data-accordion-max-height', 'auto');
      }

      function forceReflow() {
        // Accessing offsetHeight forces a reflow to ensure transitions fire reliably
        return content.offsetHeight;
      }

      function openWithAnimation() {
        // If previously set to auto, collapse to 0 first to start animation
        if (content.getAttribute('data-accordion-max-height') === 'auto') {
          content.style.maxHeight = '0px';
          forceReflow();
        }
        content.style.maxHeight = content.scrollHeight + 'px';

        var onEnd = function (event) {
          if (event.target !== content) return;
          content.removeEventListener('transitionend', onEnd);
          // Allow natural height after opening completes
          if (details.open) setMaxHeightNone();
        };
        content.addEventListener('transitionend', onEnd);
      }

      function closeWithAnimation() {
        // From auto → pixel → 0 to animate close
        if (content.getAttribute('data-accordion-max-height') === 'auto') {
          content.style.maxHeight = content.scrollHeight + 'px';
          forceReflow();
        }
        content.style.maxHeight = '0px';
        content.removeAttribute('data-accordion-max-height');
      }

      // Initialize state
      if (details.open) {
        setMaxHeightNone();
      } else {
        content.style.maxHeight = '0px';
      }

      details.addEventListener('toggle', function () {
        if (details.open) {
          openWithAnimation();
        } else {
          closeWithAnimation();
        }
      });
    });
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAccordionAnimations(document);
    });
  } else {
    initializeAccordionAnimations(document);
  }

  // Handle dynamic section loads in the editor and other AJAX updates
  document.addEventListener('shopify:section:load', function (event) {
    initializeAccordionAnimations(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initializeAccordionAnimations(event.target);
  });

  // Keep open accordions natural height on resize
  window.addEventListener('resize', function () {
    var openContents = Array.prototype.slice.call(
      document.querySelectorAll('.accordion details[open] .accordion__content')
    );
    openContents.forEach(function (content) {
      if (!(content instanceof HTMLElement)) return;
      content.style.maxHeight = 'none';
      content.setAttribute('data-accordion-max-height', 'auto');
    });
  });
})();


